import React from 'react';
import { Helmet } from 'react-helmet-async';

interface ServiceSchemaProps {
  serviceName: string;
  description: string;
  serviceType: string;
  areaServed: string[];
  priceRange?: string;
  additionalServices?: string[];
}

const ServiceSchema: React.FC<ServiceSchemaProps> = ({
  serviceName,
  description,
  serviceType,
  areaServed,
  priceRange = "$$",
  additionalServices = []
}) => {
  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": serviceName,
    "description": description,
    "serviceType": serviceType,
    "provider": {
      "@type": "LocalBusiness",
      "name": "Ventura Power Washing",
      "telephone": "(805) 464-7166",
      "url": "https://www.venturapowerwashing.com",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Ventura",
        "addressRegion": "CA",
        "addressCountry": "US"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "34.2804",
        "longitude": "-119.2949"
      },
      "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        "opens": "07:00",
        "closes": "19:00"
      },
      "paymentAccepted": "Cash, Check, Credit Card",
      "priceRange": priceRange
    },
    "areaServed": areaServed.map(area => ({
      "@type": "City",
      "name": area,
      "containedInPlace": {
        "@type": "State",
        "name": "California"
      }
    })),
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": `${serviceName} Services`,
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": serviceName,
            "description": description
          }
        },
        ...additionalServices.map(service => ({
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": service,
            "description": `Professional ${service.toLowerCase()} services in Ventura County`
          }
        }))
      ]
    },
    "potentialAction": {
      "@type": "OrderAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://www.venturapowerwashing.com/#contact",
        "inLanguage": "en-US",
        "actionPlatform": [
          "http://schema.org/DesktopWebPlatform",
          "http://schema.org/MobileWebPlatform"
        ]
      },
      "deliveryMethod": "http://schema.org/OnSitePickup"
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(serviceSchema)}
      </script>
    </Helmet>
  );
};

export default ServiceSchema;